const MAX_LENGTH = 100;

export const truncateQueueLabel = (
  queueName: string,
  workspaceName?: string
) => {
  const fullLabel = workspaceName
    ? `${queueName} (${workspaceName})`
    : queueName;

  if (fullLabel.length <= MAX_LENGTH) {
    return { truncatedLabel: fullLabel, showTooltip: false, fullLabel };
  }

  if (!workspaceName) {
    const truncatedLabel = `${queueName.slice(0, MAX_LENGTH - 3)}...`;
    return { truncatedLabel, showTooltip: true, fullLabel };
  }

  // Calculate how much space we have for each part
  // Format: "queueName (workspaceName)"
  // We need space for " (" and ")" = 3 chars, plus "..." = 3 chars
  const availableLength = MAX_LENGTH - 6; // for " (...)"
  const halfLength = Math.floor(availableLength / 2);

  const truncatedQueueName =
    queueName.length > halfLength
      ? `${queueName.slice(0, halfLength)}...`
      : queueName;

  const remainingLength =
    availableLength - Math.min(queueName.length, halfLength);
  const truncatedWorkspaceName =
    workspaceName.length > remainingLength
      ? `${workspaceName.slice(0, remainingLength)}...`
      : workspaceName;

  const truncatedLabel = `${truncatedQueueName} (${truncatedWorkspaceName})`;

  return { truncatedLabel, showTooltip: true, fullLabel };
};
